import axios from 'axios'
import join from 'url-join'

import { getApirAddr, getCompanyInfo } from './api'

let token = localStorage.getItem('token')
export let apir = null
export let cinfo = null
const instance = axios.create()
const isAbsoluteURLRegex = /^(?:\w+:)\/\//

export const getToken = async (username, password, shouldNavigate = true) => {
  try {
    const res = await axios({
      method: 'POST',
      url: `${process.env.REACT_APP_BASE_URL}/api/authenticate`,
      data: { Username: username, Password: password },
      headers: { 'Content-Type': 'application/json' }
    })

    token = res.data.token
    localStorage.setItem('token', token)
    return res
  } catch (error) {
    console.error('Error getting token', error)

    if (error.response.status === 406 && shouldNavigate) {
      if (window.location.pathname !== '/login') window.location.href = '/login'
    } else {
      //throw error
    }
  }
}

export const getCinfo = async () => {
  if (cinfo) return
  cinfo = await getCompanyInfo()
}

export const getApir = async (companyId) => {
  if (apir) return
  const res = await getApirAddr(companyId)

  if (window.location.hostname !== 'localhost' && window.location.hostname !== 'dd.connectplus.parts') {
    if (window.location.hostname !== res.CompanyDomain) {
      throw new Error('This is not your server.')
      return
    }
  }


  apir = `https://${res.CompanyDomain}/api`
  if (!apir) window.location.href = '/error'
}

instance.interceptors.request.use(
  async (config) => {
    if (!token) await getToken()
    config.headers.token = token
    config.headers.Authorization = `Bearer ${token}`

    if (!isAbsoluteURLRegex.test(config.url)) {
      if (!apir) throw new Error('Tried APIR req before APIR URL loaded')
      config.url = join(apir, config.url)
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  (response) => {
    return response.data
  },
  async (error) => {
    console.log(error)
    const originalRequest = error.config

    if (!error.response) {
      return Promise.reject(error)
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      await getToken()
      originalRequest.headers.token = token
      originalRequest.headers.Authorization = `Bearer ${token}`
      return instance(originalRequest)
    }

    if (error.response.status === 401) {
      if (window.location.pathname !== '/login') window.location.href = '/login'
      return
    }

    return Promise.reject(error)
  }
)

export default instance